"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTroubleshootTimes = exports.requestTroubleshootTimesRejected = exports.receiveTroubleshootTimes = exports.requestTroubleshootTimes = exports.troubleshootActionTypes = void 0;

var _troubleshootAPI = require("../../api/troubleshootAPI");

var _noPortalApiClient = _interopRequireDefault(require("hub-http/clients/noPortalApiClient"));

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var troubleshootActionTypes = {
  REQUEST_TROUBLESHOOT_TIMES: 'REQUEST_TROUBLESHOOT_TIMES',
  RECEIVE_TROUBLESHOOT_TIMES: 'RECEIVE_TROUBLESHOOT_TIMES',
  REQUEST_TROUBLESHOOT_TIMES_REJECTED: 'REQUEST_TROUBLESHOOT_TIMES_REJECTED'
};
exports.troubleshootActionTypes = troubleshootActionTypes;
var REQUEST_TROUBLESHOOT_TIMES = troubleshootActionTypes.REQUEST_TROUBLESHOOT_TIMES,
    RECEIVE_TROUBLESHOOT_TIMES = troubleshootActionTypes.RECEIVE_TROUBLESHOOT_TIMES,
    REQUEST_TROUBLESHOOT_TIMES_REJECTED = troubleshootActionTypes.REQUEST_TROUBLESHOOT_TIMES_REJECTED;

var requestTroubleshootTimes = function requestTroubleshootTimes() {
  return {
    type: REQUEST_TROUBLESHOOT_TIMES
  };
};

exports.requestTroubleshootTimes = requestTroubleshootTimes;

var receiveTroubleshootTimes = function receiveTroubleshootTimes(data) {
  return {
    type: RECEIVE_TROUBLESHOOT_TIMES,
    data: data
  };
};

exports.receiveTroubleshootTimes = receiveTroubleshootTimes;

var requestTroubleshootTimesRejected = function requestTroubleshootTimesRejected(err) {
  return {
    type: REQUEST_TROUBLESHOOT_TIMES_REJECTED,
    err: err
  };
};

exports.requestTroubleshootTimesRejected = requestTroubleshootTimesRejected;

var fetchTroubleshootTimes = function fetchTroubleshootTimes() {
  return function (dispatch, getState) {
    var slug = getState().userSlug;
    var portalId = (0, _getIn.default)(['bookInfo', 'portalId'])(getState());
    dispatch(requestTroubleshootTimes());
    return (0, _troubleshootAPI.fetchTroubleshootTimesRequest)(_noPortalApiClient.default, slug, portalId).then(function (response) {
      return dispatch(receiveTroubleshootTimes(response));
    }).catch(function (err) {
      return dispatch(requestTroubleshootTimesRejected(err));
    });
  };
};

exports.fetchTroubleshootTimes = fetchTroubleshootTimes;